"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAll = getAll;
exports.getAllBySocieteId = getAllBySocieteId;
exports.getById = getById;
exports.getByRole = getByRole;
exports.update = update;
exports.insert = insert;
exports.deleteById = deleteById;
exports.bulkDelete = bulkDelete;
exports.getBySocieteRole = getBySocieteRole;

var _request = _interopRequireDefault(require("@/helpers/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAll() {
  return (0, _request.default)({
    url: '/permission',
    method: 'get'
  });
}

function getAllBySocieteId(id) {
  return (0, _request.default)({
    url: '/permission/societe/' + id,
    method: 'get'
  });
}

function getById(id) {
  return (0, _request.default)({
    url: '/permission/' + id,
    method: 'get'
  });
}

function getByRole(id) {
  return (0, _request.default)({
    url: '/permission/role' + id,
    method: 'get'
  });
}

function update(id, data) {
  return (0, _request.default)({
    url: '/permission/' + id,
    method: 'put',
    data: data
  });
}

function insert(data) {
  return (0, _request.default)({
    url: '/permission',
    method: 'post',
    data: data
  });
}

function deleteById(id) {
  return (0, _request.default)({
    url: '/permission/' + id,
    method: 'delete'
  });
}

function bulkDelete(ids) {
  return (0, _request.default)({
    url: '/permission/' + ids,
    method: 'delete'
  });
} // ---------------------------


function getBySocieteRole(idSociete, keyRole) {
  return (0, _request.default)({
    url: '/permission/societe/' + idSociete + '/role/' + keyRole,
    method: 'get'
  });
}